import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEvents} from "../../shared/dto/aps.events";
import * as angular from "angular";
import {SignalRHub} from "../hubs/signalr-hub";
import HubServiceName, {HubService} from "../hubs/hub.service";

export interface GobWeightsHubService {
  createGobWeightsHub(shopId: string,
                      addGobWeight: (weight: apsViewModels.GobWeightItem) => void,
                      addGobWeightComment: (comment: apsEvents.GobWeightCommentAdded) => void)
    : GobWeightsHub;
}

export interface GobWeightsHub extends SignalRHub {
  joinGroup(shopId: string): Promise<any>;
  leaveGroup(shopId: string): Promise<any>;
}

class GobWeightsHubServiceImpl implements GobWeightsHubService {
  private $timeout: angular.ITimeoutService;
  private hubService: HubService;

  constructor($timeout: angular.ITimeoutService,
              hubService: HubService) {
    this.$timeout = $timeout;
    this.hubService = hubService;
  }

  createGobWeightsHub(shopId: string, addGobWeight: (weight: apsViewModels.GobWeightItem) => void,
                      addGobWeightComment: (comment: apsEvents.GobWeightCommentAdded) => void): GobWeightsHub {
    let self = this;

    let gobWeightsHub = this.hubService.createHub<GobWeightsHub>('gobWeights', {
      listeners: {
        gobWeightAdded: function(gobWeight) {
          self.$timeout(() => addGobWeight(gobWeight));
        },
        gobWeightCommentAdded: function(gobWeightComment) {
          self.$timeout(() => addGobWeightComment(gobWeightComment));
        }
      },
      methods: ['leaveGroup', 'joinGroup'],
      postConnect: (hub: GobWeightsHub) => {
        hub.invokeWithRetry(() => hub.joinGroup(shopId));
      }
    });

    return gobWeightsHub;
  }
}

export default angular.module('aps.hubs.gobWeights', [HubServiceName])
  .service('gobWeightsHubService', GobWeightsHubServiceImpl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/reports/gobWeights.hub.ts